/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetElements } from '../elements/widget-elements-base';

export abstract class WidgetContext {
  public constructor(protected elements: WidgetElements) {}

  public abstract initialize(): void;

  public deinitialize() {
  }

  public localize() {
  }

  public setInitialFocus() {
  }

  public validateForm() {
  }

  public get wide() {
    return false;
  }

  public get supported() {
    return true;
  }

  public hasContextMutated() {
    return false;
  }
}
